/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_G2Inputs */

const en_mk_mx_g2 = /** @type {(inputs: Mk_Mx_G2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents & execution`)
};

const id_mk_mx_g2 = /** @type {(inputs: Mk_Mx_G2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen & eksekusi`)
};

/**
* | output |
* | --- |
* | "Agents & execution" |
*
* @param {Mk_Mx_G2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_g2 = /** @type {((inputs?: Mk_Mx_G2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_G2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_g2(inputs)
	return en_mk_mx_g2(inputs)
});